// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__PIWJb","title":"Header_title__XMZGx"};